import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'tiret',
  standalone: true,
})
export class TiretPipe implements PipeTransform {
  transform(value: any): string {
    if (value === null || value === undefined || value === '') {
        return '-';
    }
    return value;
}

}
